import axios from "axios";
import { FETCH_OFFICER_PERMISSIONS, GET_ALL_DEPARTMENTS, GET_ALL_OFFICERS_LIST, GET_ALL_PERMISSIONS, GET_ALL_ROLES, GET_ELIGIBLE_OFFICERS, GET_OFFICER_PROFILE, GET_OFFICER_PROFILE_ERROR, GET_OFFICER_PROFILE_LOADING, GET_OFFICERS, USER_ERROR, USER_LOADER } from "../actionType";
import { toast } from "react-toastify";
import { logout } from "../AuthReducer/action";
import { getAuthToken } from "../../utils/auth";

export const getOfficers = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    let queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.branch_code){
        queryParams.append("branch_code", filters?.branch_code);
    }
    if(filters?.branch_name){
        queryParams.append("branch_name", filters?.branch_name);
    }
    if(filters?.emp_id){
        queryParams.append("emp_id", filters?.emp_id);
    }
    if(filters?.first_name){
        queryParams.append("first_name", filters?.first_name);
    }
    if(filters?.last_name){
        queryParams.append("last_name", filters?.last_name);
    }
    if(filters?.email){
        queryParams.append("email", filters?.email);
    }
    if(filters?.role_code){
        queryParams.append("role_code", filters?.role_code);
    }
    if(filters?.manager_id){
        queryParams.append("manager_id", filters?.manager_id);
    }
    if(filters?.is_active){
        queryParams.append("is_active", filters?.is_active);
    }
    if(!filters?.is_login == null && !filters?.is_login == '' && !filters?.is_login == undefined){
        queryParams.append("is_login", filters?.is_login);
    }
    if(filters?.state_name){
        queryParams.append("state_name", filters?.state_name);
    }
    if(filters?.global_search){
        queryParams.append("global_search", filters?.global_search);
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/get-branch-officer-report?${queryParams?.toString()}`, { headers });

        dispatch({ type: GET_OFFICERS, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}

export const getAllOfficerList = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    let queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.branch_code){
        queryParams.append("branch_code", filters?.branch_code);
    }
    if(filters?.branch_name){
        queryParams.append("branch_name", filters?.branch_name);
    }
    if(filters?.role_code){
        queryParams.append("role_code", filters?.role_code);
    }
    if(filters?.emp_id){
        queryParams.append("emp_id", filters?.emp_id);
    }
    if(filters?.officer_id){
        queryParams.append("officer_id", filters?.officer_id);
    }
    if(filters?.first_name){
        queryParams.append("first_name", filters?.first_name);
    }
    if(filters?.last_name){
        queryParams.append("last_name", filters?.last_name);
    }
    if(filters?.email){
        queryParams.append("email", filters?.email);
    }
    if(filters?.is_active === true || filters?.is_active === false){
        queryParams.append("is_active", filters?.is_active);
    }
    if(filters?.global_search){
        queryParams.append("global_search", filters?.global_search);
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/get-all-officer?${queryParams?.toString()}`, { headers });

        dispatch({ type: GET_ALL_OFFICERS_LIST, payload: response?.data?.data });

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.total_pages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total_records || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.current_page || 1);
        sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}

export const getAllPermissions = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    let queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.permission_code){
        queryParams.append("permission_code", filters?.permission_code);
    }
    if(filters?.module_name){
        queryParams.append("module_name", filters?.module_name);
    }
    if(filters?.search){
        queryParams.append("search", filters?.search);
    }
    if(filters?.action){
        queryParams.append("action", filters?.action);
    }
    if(filters?.is_active === false || filters?.is_active === true){
        queryParams.append("is_active", filters?.is_active);
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/administration/get-all-permissions?${queryParams?.toString()}`, { headers });

        dispatch({ type: GET_ALL_PERMISSIONS, payload: response?.data?.data?.data });
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}

export const getAllRoles = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    let queryParams = new URLSearchParams({
        page, 
        limit
    });

    if(filters?.role_name){
        queryParams.append("role_name", filters?.role_name);
    }
    if(filters?.is_active === true || filters?.is_active === false){
        queryParams.append("is_active", filters?.is_active);
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/masters/get-role?${queryParams?.toString()}`, { headers });

        dispatch({ type: GET_ALL_ROLES, payload: response?.data?.data });

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.total_pages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total_records || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.current_page || 1);
        // sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
        sessionStorage.setItem('allRolesLimit', response?.data?.data?.pagination?.limit || 10);
        
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        // let errorMsg = error?.response?.data?.message;
        // toast.error(`${errorMsg}`);
    }
}

export const getAllDepartments = async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/administration/get-departments`, { headers });

        dispatch({ type: GET_ALL_DEPARTMENTS, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}

export const getEligibleOfficers = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: USER_ERROR });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    let queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.application_branch_code){
        queryParams.append("application_branch_code", filters?.application_branch_code);
    }
    if(filters?.role_code){
        queryParams.append("role_code", filters?.role_code);
    }

    try {
        dispatch({ type: USER_LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/branch-eligible-officers?${queryParams?.toString()}`, { headers });

        dispatch({ type: GET_ELIGIBLE_OFFICERS, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: USER_ERROR });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}

// export const fetchOfficerPermissions = (filters) => async (dispatch) => {
//     let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
//     let authToken = tokens?.token || null;

//     if (!authToken) {
//         dispatch({ type: USER_ERROR });
//         return;
//     }

//     let headers = {
//         Authorization: `Bearer ${authToken}`,
//         accept: '*/*',
//     }

//     try {
//         dispatch({ type: USER_LOADER });

//         let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/administration/officer-permissions/${filters?.emp_id}`, { headers });

//         dispatch({ type: FETCH_OFFICER_PERMISSIONS, payload: response?.data?.data });
//     }
//     catch (error) {
//         dispatch({ type: USER_ERROR });
//         let errorMsg = error?.response?.data?.message;
//         toast.error(`${errorMsg}`);
//     }
// }

export const getOfficerProfile = async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || JSON.parse(localStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: GET_OFFICER_PROFILE_ERROR, payload: "Invalid authentication token" });
        return;
    }

    let headers = {
        Authorization: `Bearer ${authToken}`,
        accept: '*/*',
    }

    try {
        dispatch({ type: GET_OFFICER_PROFILE_LOADING });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/profile/get`, { headers });

        dispatch({ type: GET_OFFICER_PROFILE, payload: response?.data?.data });
    }
    catch (error) {
        console.log({ logo: error?.response?.data?.statusCode });

        if(error?.response?.data?.statusCode === 401){
            dispatch(logout);
            return;
        }

        dispatch({ type: GET_OFFICER_PROFILE_ERROR, payload: "Error while fetching officer profile" });
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
    }
}